import { IActivePassesState } from '../nested-states/active-passes/states';
import { IExpiredPassesState } from '../nested-states/expired-passes/states';
import { IFromLocationState } from '../nested-states/from-location/states';
import { IFuturePassesState } from '../nested-states/future-passes/states';
import { IHallMonitorPassesState } from '../nested-states/hall-monitor-passes/states';
import { IInvitationsState } from '../nested-states/invitations/invitations.state';
import { IRequestsState } from '../nested-states/requests/states';
import { IToLocationState } from '../nested-states/to-location/states';

export interface IPassLikeCollectionState {
	invitations?: IInvitationsState;
	requests?: IRequestsState;
	expiredPasses?: IExpiredPassesState;
	futurePasses?: IFuturePassesState;
	activePasses?: IActivePassesState;
	toLocation?: IToLocationState;
	fromLocation?: IFromLocationState;
	hallMonitorPasses?: IHallMonitorPassesState;
}

export const passLikeCollectionInitialState: IPassLikeCollectionState = {};
